'use strict';

module.exports = require('./config');


//////////////////
// WEBPACK FOOTER
// ./src/config/index.js
// module id = 193
// module chunks = 0